import { UserCircleIcon } from '@heroicons/react/20/solid';
import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate, usePathname } from '../../navigation';
import { TTUserProfile } from '../../interfaces/user';
import { RootState } from '../../rootReducer';

type Props = {};

export function GuestAccessPoint() {
  const guestProfile = useSelector<RootState, TTUserProfile | null>(
    state => state.auth.userProfile,
  );
  const pathname = usePathname();
  const navigate = useNavigate();
  if (guestProfile === null || guestProfile === undefined) {
    return <></>;
  }
  if (pathname.match(/(guests)\//gm)) {
    return <></>;
  }
  return (
    <>
      <div className="relative">
        <div
          className="fixed right-5 bottom-16"
          style={{
            width: '48px',
            height: '50px',
            padding: '0px',
            margin: '10px 20px',
            position: 'fixed',
            bottom: '54px',
            overflow: 'visible',
            opacity: '1',
            border: '0px',
            zIndex: '999998',
            transitionDuration: '250ms',
            transitionTimingFunction: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
            transitionProperty: 'opacity top bottom',
            right: '0px',
          }}
        >
          <div
            className="bg-primary rounded-full px-3 py-3"
            onClick={() => {
              navigate('guests/');
            }}
          >
            <UserCircleIcon className="h-6 w-6 text-on-primary" />
          </div>
        </div>
      </div>
    </>
  );
}
